import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="animate-pulse text-muted-foreground font-body">Loading…</div>
      </div>
    );
  }

  if (!user) {
    /**
     * PRESERVE PRODUCT IDENTITY THROUGH SIGN-IN.
     * A Free Scan ready-email CTA (`/app/overview?scan=<scan_id>`) clicked
     * while signed out must return to the SAME scan after authentication, so
     * the intended destination (path + query) travels as `next`.
     */
    const intended = `${location.pathname}${location.search}`;
    const target = `/auth/sign-in?next=${encodeURIComponent(intended)}`;
    return <Navigate to={target} replace />;
  }

  return <>{children}</>;
}
